import { render } from "./MatchingRetrievalInfos.vue?vue&type=template&id=20b13995&scoped=true&ts=true&lang=pug"
import script from "./MatchingRetrievalInfos.vue?vue&type=script&lang=ts"
export * from "./MatchingRetrievalInfos.vue?vue&type=script&lang=ts"

import "./MatchingRetrievalInfos.vue?vue&type=style&index=0&id=20b13995&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20b13995"]])

export default __exports__